import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useNavigate } from 'react-router-dom';
import * as Yup from "yup";
import '../../stylesheets/Margins.css';
import '../../stylesheets/LoginForm.css';
import LockIcon from '@mui/icons-material/Lock';
import EmailIcon from '@mui/icons-material/Email';
import projectLogo from '../../project_logo.png'
import { AuthAPI } from "../../axios";

const LoginSchema = Yup.object().shape({
  email: Yup
    .string()
    .email("Invalid email address")
    .required("Email is required"),
  password: Yup.string().required("Password is required"),
});

const LoginPage = () => {
  const navigate = useNavigate();

  const handleSubmit = (values) => {
    AuthAPI.login(JSON.stringify(values))
      .then((res) => {
        if (res.code === 200) {
          localStorage.setItem("accessToken", res.data.token);
          localStorage.setItem("adminData", JSON.stringify(res.data.adminObject));
          navigate('/dashboard');
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onForget = () => {
    navigate('/forget-password')
  }

  return (
    <div className="login-container">
      <img
        src={projectLogo}
        alt="Profile"
        style={{
          width: '150px',
          height: '150px',
          borderRadius: '50%',
          objectFit: 'cover',
        }}
      />
      <div className="login-header">
        <h1 className="text">Sign In</h1>
      </div>
      <Formik
        initialValues={{ email: '', password: '' }}
        validationSchema={LoginSchema}
        onSubmit={handleSubmit}
      >
        {() => (
          <Form className="inputs">
            <span className="input-label">Email</span>
            <div>
              <div className="input">
                <EmailIcon />
                <Field name="email" type="email" placeholder="Enter email" />
              </div>
              <ErrorMessage name="email" component="div" className="error" style={{ marginTop: '0px', marginLeft: '0px' }} />
            </div>
            <span className="input-label">Password</span>
            <div>
              <div className="input">
                <LockIcon />
                <Field name="password" type="password" placeholder="Enter password" />
              </div>
              <ErrorMessage name="password" component="div" className="error" style={{ marginTop: '0px', marginLeft: '0px' }} />
            </div>
            <span className="forgot-password" onClick={onForget}>Forgot Password?</span>
            <div className="margin20">
              <button type="submit" className="submit">Sign In</button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default LoginPage;
